// This file is autogenerated from /frontend/sail-next/packages/docs/src/markdoc/demo/textfield/DisabledReadOnly.story.tsx with go/sail-next-tailor-docs-publisher 

import * as React from 'react';
import { TextField, view } from '@sail/ui';
export const DisabledReadOnly = () => <view.div css={{
  layout: 'column',
  gap: 'medium'
}}>
    <TextField label="Disabled" defaultValue="Field is disabled" disabled />
    <TextField label="Readonly" defaultValue="Field is readonly" readOnly />
  </view.div>;